export function buildQuizSummary(questions = [], answersByQuestion = {}) {
  return questions.map(question => ({
    question: question.question,
    answers: (question.answers || [])
      .filter(answer => (answersByQuestion[question.id] || []).includes(answer.id))
      .map(answer => ({ answerId: answer.id, title: answer.title })),
  }))
}

export function findFirstUnansweredQuestion(questions = [], answersByQuestion = {}) {
  return questions.findIndex(question => !(answersByQuestion[question.id] || []).length)
}

export function mapQuizResult(response, quiz) {
  if (!response) return null

  const requiredPercentage = Number(quiz?.percentage ?? response.expectedMin ?? 0)
  if (response.approved === true) {
    return {
      isApproved: true,
      achievedPercentage: Number(response.userPercent ?? 0),
      requiredPercentage,
      incorrectQuestions: [],
      remainingAttempts: undefined,
      blocked: false,
      message: response.message,
      certificateApproval: response.certificateApproval || null,
    }
  }

  const questionsById = new Map(
    (quiz?.questions || []).map(question => [question?.id, question])
  )

  return {
    isApproved: false,
    achievedPercentage: Number(response.userPercent ?? 0),
    requiredPercentage,
    incorrectQuestions: (Array.isArray(response.wrong) ? response.wrong : []).map(item => ({
      id: item.id,
      question: item.question || questionsById.get(item.id)?.question || `Question #${item.id}`,
      lessonTitle: item.lesson || '',
      received: item.received || [],
      status: item.status || '',
    })),
    remainingAttempts: typeof response.remainingAttempts === 'number'
      ? response.remainingAttempts
      : undefined,
    blocked: response.remainingAttempts === 0 && !!response.message,
    message: response.message,
    certificateApproval: null,
  }
}
